import React, {
    useCallback,
    useMemo,
    useState,
} from 'react';
import { buildClassNames } from '@frontend/jetlend-web-ui/src/utils/classNameUtils';
import { useWindowSize } from '@frontend/jetlend-web-ui/src/utils/responsive';
import Image from '@app/components/Image/Image';
import moreIcon from '@app/icons/arrow-more.svg';
import { IAchievementItemApiModel } from '@app/models/features/course';
import AchievementItem from '@app/features/academy/achievement/AchievementItem/AchievementItem';
import styles from './AchievementBlock.module.scss';

export interface IProps {
    /**
     * Список ачивок
     */
    achievements: IAchievementItemApiModel[];
}

/**
 * Функция, для определяющая в каких случаях отображать кнопку "Посмотреть все"
 * @param size ширина экрана
 * @param count количество ачивок
 */
const getShowMoreCases = (size: number, count:number): boolean => {
    switch (true) {
    case (size < 569):
        return count > 4;
    case (size < 768):
        return count > 2;
    case (size < 1200):
        return count > 3;
    case (size < 1400):
        return count > 4;
    case (size < 1600):
        return count > 5;
    }
};

/**
 * Компонент для отрисовки блока с ачивками пользователя
 */
const AchievementBlock:React.FC<IProps> = props => {
    const { achievements = [] } = props;
    const { width: screenWidth } = useWindowSize();
    const [ isShow, setShow ] = useState(false);
    const achievementsCount = achievements?.length;
    const moreButtonText = isShow ? 'Скрыть' : 'Посмотреть все';
    const isShowMoreButton = getShowMoreCases(screenWidth, achievementsCount);
    const sortAchievements = useMemo(() => achievements?.sort(item => item?.achieved ? -1 : 1), [achievements]);

    const containerClassName = buildClassNames(styles, [
        'container',
        isShow && 'container--more',
        achievementsCount <= 2 && 'container--small',
    ]);

    const arrowClassName = buildClassNames(styles, [
        'more-arrow',
        isShow && 'more-arrow--rotate',
    ]);

    const didShowMoreClicked = useCallback(() => setShow(prev => !prev), []);

    return (
        <>
            <div className={containerClassName}>
                {sortAchievements?.map((item, index) => (
                    <AchievementItem key={`${item.id}_${index}`} {...item} />
                ))}
            </div>
            {isShowMoreButton && (
                <div className={styles['more']} onClick={didShowMoreClicked}>
                    {moreButtonText}
                    <Image className={arrowClassName} src={moreIcon} alt="" width={18} height={12} />
                </div>
            )}
        </>
    );
};

export default AchievementBlock;